import type { IntlShape } from 'react-intl';
import type { PriceImprovementEvent } from 'utils/streaming/model';

export function handlePriceImprovementEvent(intl: IntlShape) {
  return function (event: PriceImprovementEvent) {
    const { translatedTitle, translatedBody } = translateEvent(event, intl);
    new Notification(translatedTitle, { body: translatedBody, requireInteraction: true });
  };
}

function translateEvent(event: PriceImprovementEvent, intl: IntlShape) {
  const { formatMessage } = intl;
  switch (event.type) {
    case 'PriceImprovementCreated':
      return {
        translatedTitle: formatMessage({ id: 'priceImprovement.notification.created.title' }),
        translatedBody: formatMessage(
          { id: 'priceImprovement.notification.created.body' },
          { quoteId: event.quoteId, sales: event.sales, comment: event.comment },
        ),
      };
    case 'PriceImprovementAcknowledged':
      return {
        translatedTitle: formatMessage({ id: 'priceImprovement.notification.acknowledged.title' }),
        translatedBody: formatMessage(
          { id: 'priceImprovement.notification.acknowledged.body' },
          { trader: event.trader, quoteId: event.externalQuoteId },
        ),
      };
    case 'PriceImprovementRejected':
      return {
        translatedTitle: formatMessage({ id: 'priceImprovement.notification.rejected.title' }),
        translatedBody: formatMessage(
          { id: 'priceImprovement.notification.rejected.body' },
          { quoteId: event.externalQuoteId, trader: event.trader, comment: event.comment },
        ),
      };
    case 'PriceImprovementValidated':
      return {
        translatedTitle: formatMessage({ id: 'priceImprovement.notification.validated.title' }),
        translatedBody: formatMessage(
          { id: 'priceImprovement.notification.validated.body' },
          {
            quoteId: event.externalQuoteId,
            trader: event.trader,
            priceAdjustment: event.priceAdjustment,
            comment: event.comment,
          },
        ),
      };
  }
}
